/**
 * localStorage-backed per-user broadcast identity. The stream code is a stable,
 * shareable handle for this device's broadcast (one stream per user); the
 * display name + broadcasting flag are user preferences that round-trip across
 * reloads so a refresh-while-broadcasting can re-open the stream automatically.
 */
const CODE_KEY = 'casino.stream_code';
const NAME_KEY = 'casino.stream_name';
const BROADCASTING_KEY = 'casino.broadcasting';

/**
 * 8-char base36 code. Secure-context-safe — mirrors sessionStorage.ts's
 * randomUuid fallback so plain-HTTP LAN access (where crypto.randomUUID throws)
 * still mints a code.
 */
function randomCode(): string {
  const bytes = new Uint8Array(6);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (let i = 0; i < 6; i++) bytes[i] = Math.floor(Math.random() * 256);
  let s = '';
  for (const b of bytes) s += (b % 36).toString(36);
  return s;
}

export function getOrCreateStreamCode(): string {
  let c = localStorage.getItem(CODE_KEY);
  if (!c) { c = randomCode(); localStorage.setItem(CODE_KEY, c); }
  return c;
}
export function getStreamCode(): string | null { return localStorage.getItem(CODE_KEY); }
export function getDisplayName(): string | null { return localStorage.getItem(NAME_KEY); }
export function setDisplayName(name: string): void { localStorage.setItem(NAME_KEY, name.slice(0, 40)); }
export function isBroadcasting(): boolean { return localStorage.getItem(BROADCASTING_KEY) === '1'; }
export function setBroadcasting(on: boolean): void {
  if (on) localStorage.setItem(BROADCASTING_KEY, '1'); else localStorage.removeItem(BROADCASTING_KEY);
}
